import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import MaskReal from 'services/formateRS';
import api from "assets/services/api";


function ModalUpdateTabulation(props) {

    const [br, setBR] = useState(false);


    const [price_of_product, setPrice_of_product] = useState(props.props.price_of_product);
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);


    async function handleUpdateTabulation(e) {
        e.preventDefault();
        const response = await api.put('/tabulation/' + props.props.id, {
            price_of_product,
            id_client: props.id_client,
            id_product: props.props.id_product,
            id_admin: props.props.id_admin
        });
        if (response.status === 200) {
            setControlSnack(true);
            props.handleShowTabulation();
            props.onHide();
        }
    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar tabela de preço {props.props.name}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateTabulation}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Valor de venda do produto</Form.Label>
                            <MaskReal value={price_of_product} onChange={value => setPrice_of_product(value.replace(',', '.'))} />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Salvar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Tabela de preço adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateTabulation;